// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  theme: {
    defaultTheme: 'brandTheme',
    themes: {
      brandTheme: {
        dark: false,
        colors: {
          primary: '#002060', // Brand Blue
          secondary: '#BCA258', // Brand Gold
          accent: '#001547', // Dark Blue
          error: '#f44336', // Red
          warning: '#ff9800', // Orange
          info: '#2196f3', // Blue
          success: '#4caf50', // Green
          background: '#f2f2f2', // Light Grey Background
          surface: '#ffffff', // White Surface
          'on-primary': '#ffffff', // Text on primary
          'on-secondary': '#000000', // Text on secondary
          'on-background': '#002060', // Text on background
          'on-surface': '#002060', // Text on surface
        },
      },
    },
  },
})
